import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "c-equivalence" }
const _hoisted_2 = { class: "c-equivalence__search" }
const _hoisted_3 = { class: "c-equivalence__search__inner" }
const _hoisted_4 = { class: "o-title-4 c-equivalence__search__title" }
const _hoisted_5 = { class: "o-form c-equivalence__search__form" }
const _hoisted_6 = { class: "o-form-row" }
const _hoisted_7 = { class: "o-form__item" }
const _hoisted_8 = { class: "o-radio__wrap" }
const _hoisted_9 = {
  class: "o-radio-label",
  for: "externe"
}
const _hoisted_10 = { class: "o-form__item" }
const _hoisted_11 = { class: "o-radio__wrap" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "c-equivalence__search__form__items" }
const _hoisted_14 = {
  id: "institution-externe",
  class: "o-form-row"
}
const _hoisted_15 = {
  key: 0,
  class: "o-form__item w-fill"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "o-select__wrap" }
const _hoisted_18 = {
  value: null,
  disabled: "",
  selected: ""
}
const _hoisted_19 = ["value", "innerHTML"]
const _hoisted_20 = {
  class: "o-ico -ico-arrow-down",
  role: "img"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("title", null, "arrow-down", -1 /* HOISTED */)
const _hoisted_22 = ["xlink:href"]
const _hoisted_23 = { class: "o-form__item w-200" }
const _hoisted_24 = {
  key: 0,
  class: "o-label c-equivalence__search__form__label",
  for: "sigle-ou-code"
}
const _hoisted_25 = {
  key: 1,
  class: "o-label c-equivalence__search__form__label",
  for: "sigle-ou-code"
}
const _hoisted_26 = { class: "o-form__item w-fill" }
const _hoisted_27 = {
  class: "o-label c-equivalence__search__form__label",
  for: "nom-externe"
}
const _hoisted_28 = {
  key: 0,
  class: "c-equivalence__results"
}
const _hoisted_29 = { class: "c-equivalence__results__count" }
const _hoisted_30 = { class: "o-table o-table-responsive -bordered c-equivalence__table" }
const _hoisted_31 = {
  key: 0,
  colspan: "2"
}
const _hoisted_32 = {
  key: 1,
  colspan: "2"
}
const _hoisted_33 = { colspan: "2" }
const _hoisted_34 = ["data-label"]
const _hoisted_35 = ["data-label"]
const _hoisted_36 = { "data-label": "Status" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("title", null, "equivalence.status", -1 /* HOISTED */)
const _hoisted_38 = ["xlink:href"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 2 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString($options.t('Rechercher par :')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "o-radio",
                  type: "radio",
                  id: "externe",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.selectedTypeFilter) = $event)),
                  value: "externe",
                  checked: ""
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, $data.selectedTypeFilter]
                ]),
                _createElementVNode("label", _hoisted_9, _toDisplayString($options.t("Cours suivi et réussi dans une institution externe")), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  class: "o-radio",
                  type: "radio",
                  id: "interne",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedTypeFilter) = $event)),
                  value: "interne"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelRadio, $data.selectedTypeFilter]
                ]),
                _createElementVNode("label", {
                  class: "o-radio-label",
                  for: "interne",
                  innerHTML: $options.t('Cours suivi et réussi à l\'École de technologie supérieure')
                }, null, 8 /* PROPS */, _hoisted_12)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              ($data.selectedTypeFilter == 'externe')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("label", {
                      class: "o-label c-equivalence__search__form__label",
                      for: "institution",
                      innerHTML: $options.t('Nom de l\'institution *')
                    }, null, 8 /* PROPS */, _hoisted_16),
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("select", {
                        class: "o-select c-equivalence__search__form__select",
                        id: "institution",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.selectedInstitution) = $event)),
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_18, _toDisplayString($options.t("Veuillez choisir une institution")), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.institutionOptions, (institution) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: institution.value,
                            innerHTML: institution.label
                          }, null, 8 /* PROPS */, _hoisted_19))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, $data.selectedInstitution]
                      ]),
                      (_openBlock(), _createElementBlock("svg", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("use", {
                          "xlink:href": '/assets/img/sprite.svg?v=' + $options.resourceVersion + '#arrow-down'
                        }, null, 8 /* PROPS */, _hoisted_22)
                      ]))
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_23, [
                ($data.selectedTypeFilter == 'externe')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_24, _toDisplayString($options.t("Sigle ou code du cours")), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("label", _hoisted_25, _toDisplayString($options.t("Sigle du cours")), 1 /* TEXT */)),
                _withDirectives(_createElementVNode("input", {
                  class: "o-input c-equivalence__search__form__input",
                  type: "text",
                  id: "sigle-ou-code",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedSigle) = $event)),
                  placeholder: ""
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $data.selectedSigle]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString($options.t("Nom du cours")), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  class: "o-input c-equivalence__search__form__input",
                  type: "text",
                  id: "nom-externe",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.selectedName) = $event)),
                  placeholder: ""
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $data.selectedName]
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($options.showResultatSum())
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, _toDisplayString($options.countFilteredEquivalence) + " " + _toDisplayString($options.t('résultats')), 1 /* TEXT */),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = _withModifiers($event => ($options.resetFilters()), ["prevent"])),
            class: "o-button -button-reset"
          }, _toDisplayString($options.t('Réinitialiser la recherche')), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("table", _hoisted_30, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredEquivalences, (institution, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              ($data.selectedTypeFilter === 'interne')
                ? (_openBlock(), _createElementBlock("th", _hoisted_31, [
                    _createElementVNode("span", null, _toDisplayString($options.t('Cours suivi et réussi - École de technologie supérieure')), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("th", _hoisted_32, [
                    _createElementVNode("span", null, _toDisplayString(institution.name), 1 /* TEXT */)
                  ])),
              _createElementVNode("th", _hoisted_33, [
                _createElementVNode("span", null, _toDisplayString($options.t('Cours demandé pour une reconnaissance - École de technologie supérieure')), 1 /* TEXT */)
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("span", null, _toDisplayString($options.t('Statut')), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(institution.equivalences, (equivalence, idxe) => {
              return (_openBlock(), _createElementBlock("tr", { key: idxe }, [
                _createElementVNode("td", {
                  "data-label": equivalence.sigle
                }, [
                  _createElementVNode("span", null, _toDisplayString(equivalence.sigle), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_34),
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(equivalence.titre), 1 /* TEXT */)
                ]),
                _createElementVNode("td", {
                  "data-label": equivalence.sigleEts
                }, [
                  _createElementVNode("span", null, _toDisplayString(equivalence.sigleEts), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_35),
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(equivalence.titreEts), 1 /* TEXT */)
                ]),
                _createElementVNode("td", _hoisted_36, [
                  _createElementVNode("span", null, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["o-ico -ico-approved", '-ico-' + equivalence.status]),
                      role: "img"
                    }, [
                      _hoisted_37,
                      _createElementVNode("use", {
                        "xlink:href": '/assets/img/sprite.svg?v=' + $options.resourceVersion + '#' + equivalence.status
                      }, null, 8 /* PROPS */, _hoisted_38)
                    ], 2 /* CLASS */)),
                    (equivalence.status === 'approved')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                          _createTextVNode(_toDisplayString($options.t('Équivalence probable')) + " ", 1 /* TEXT */),
                          _createCommentVNode(" {{ (equivalence.message !== null) ? '&nbsp;*': '' }} "),
                          (equivalence.message !== null)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["-table-icon", (equivalence.message && $data.toggleDetails === index + '-' + idxe) ? 'is-open' : ''])
                              }, null, 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : (equivalence.status === 'not-approved')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            _createTextVNode(_toDisplayString($options.t('Non équivalent')) + " ", 1 /* TEXT */),
                            _createCommentVNode(" {{ (equivalence.message !== null && equivalence.message != '') ? '&nbsp;*' :'' }} "),
                            (equivalence.message !== null)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["-table-icon", (equivalence.message && $data.toggleDetails === index + '-' + idxe) ? 'is-open' : ''])
                                }, _toDisplayString(), 3 /* TEXT, CLASS */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : (equivalence.status === 'exception')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                              _createTextVNode(_toDisplayString($options.t('À valider')) + " ", 1 /* TEXT */),
                              _createCommentVNode(" {{ (equivalence.message !== null) ? '&nbsp;*' : '' }} "),
                              (equivalence.message !== null)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["-table-icon", (equivalence.message && $data.toggleDetails === index + '-' + idxe) ? 'is-open' : ''])
                                  }, null, 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true)
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}